import { AbstractControl, AsyncValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { UserInputCheck } from '../../core/model';
import { UserFacade } from '../../core/user';

export abstract class RegistrationFieldsValidator {
  public static emailAvailable(service: UserFacade): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (this.isFormGroup(control)) {
        throw new Error('User email validator must attach to form control');
      }
      if (!this.isValid(control)) {
        return of(null);
      }
      return timer(500) // no spamming allowed
        .pipe(
          switchMap(() => service.validateUserEmail(control.value)),
          map((check: UserInputCheck) => {
            return check.valid ? null : { registrationEmail: check };
          }),
          take(1)
        );
    };
  }

  public static usernameIsNotUsed(service: UserFacade): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (this.isFormGroup(control)) {
        throw new Error('User username validator must attach to form control');
      }
      if (!this.isValid(control)) {
        return of(null);
      }
      return timer(500) // no spamming allowed
        .pipe(
          switchMap(() => service.checkDuplicatedUsername(control.value)),
          map((check: UserInputCheck) => {
            return check.valid ? null : { username: check };
          }),
          take(1)
        );
    };
  }

  private static isFormGroup(control: AbstractControl): control is UntypedFormGroup {
    return Boolean((control as UntypedFormGroup).controls);
  }

  private static isValid(control: AbstractControl): boolean {
    return control && !!control.value;
  }
}
